export const TRIAL_DURATION_DAYS = 30;

const DAY_IN_MILLISECONDS = 24 * 60 * 60 * 1000;

export function getTrialEndDate(trialStartsAt: Date): Date {
  return new Date(trialStartsAt.getTime() + TRIAL_DURATION_DAYS * DAY_IN_MILLISECONDS);
}